import { render } from "./CandidateAutocomplete.vue?vue&type=template&id=18f2e01c&scoped=true"
import script from "./CandidateAutocomplete.vue?vue&type=script&lang=js"
export * from "./CandidateAutocomplete.vue?vue&type=script&lang=js"

import "./CandidateAutocomplete.vue?vue&type=style&index=0&id=18f2e01c&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\Peaco-v.1\\PEACO\\peacohrm-main\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18f2e01c"]])

export default __exports__